<template>
  <div class="company-stastics-box fitSize">
   
    <el-row  class="company-stastics-wrapper fitSize">
       <el-col :span="13" class="company-stastics-item left">

         <!-- 总体统计 -->
         <header class="left-hd"> 
            <el-row :gutter="20">
              <el-col :span="6">
                <img  src="../../img/ZS.png" class="x_icon" />
                <p class="span_size">有效产品</p>
                <span class="label_count zs">{{proNum}}</span>
              </el-col>
              <el-col :span="6">
                  <img  src="../../img/XZ.png" class="x_icon" />
                  <p  class="span_size">闲置产品</p>
                  <span class="label_count xz">{{proXZ}}</span>
              </el-col>
              <el-col :span="6">
                  <img  src="../../img/GQ.png" class="x_icon" />
                  <p  class="span_size">已过期产品</p>
                  <span class="label_count ygq">{{proGQ}}</span>
              </el-col>
              <el-col :span="6">
                  <img  src="../../img/JGQ.png" class="x_icon" />
                  <p  class="span_size">即将过期</p>
                  <span class="label_count jgq">{{proJGQ}}</span>
              </el-col>
            </el-row>
         </header>

         <!-- 产品统计 -->
         <article class="left-bd" style="margin-bottom: 20px">
              <header class="module-title">产品统计</header>
              <el-table  :data="products" style="width: 100%" v-loading="productLoading">
                  <el-table-column prop="logo" header-align="center" align="center" width="100px" label="产品图片">
                    <template slot-scope="scope">
                      <img slot="reference" :src="scope.row.logo" alt="logo" class="tpimg">
                    </template>
                  </el-table-column>

                  <el-table-column prop="name" label="产品名称" min-width="140" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="num"  label="产品数量" width="90" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="unUsedSum"  label="闲置产品" width="90" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="dueSum"     label="过期产品" width="90" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="dueMonthSum"  label="即将过期" width="90" show-overflow-tooltip></el-table-column>
              </el-table>  
         </article>

         <!-- 模块使用情况 -->
         <footer class="left-ft">
            <header class="module-title">模块使用情况</header>
             <el-select v-model="moduleTime" class="checkName" @change="changeTime('getCompanyMonthModulePointPie')" style="float:right">
                <el-option v-for="item in times"  :label="item.text" :key="item.value" :value="item.value"></el-option>
              </el-select>  

              <el-row class="pie-content" v-show="!masg" v-loading="moduleLoading">
                <el-col :span="14" class="pie-chart" >
                  <div id="echartModule" style="height: 100%"></div>
                </el-col>

                <el-col :span="10" class="pie-legend" v-if="modulePieArr.length > 0">
                  <div class="legend-list" v-for="(leg, index) in modulePieArr" :key="leg.moduleid">
                    <span class="circle" :style="{'background': index < pieColor.length? pieColor[index]: (pieColor[index - pieColor.length]) }"></span>
                    <span class="name">{{ leg.modulename }}</span>
                  </div>
                </el-col>
              </el-row>   

              <div v-show="masg" style="height:50px;text-align:center;color: #666;line-height:20;"> 暂无数据</div>
         </footer>
       </el-col>
       
       <!-- 右侧统计 -->
       <el-col :span="11" class="company-stastics-item right">

         <!-- 登录设备统计 TODO -->
         <header class="right-hd" style="position: relative; margin-bottom: 15px">
           <header class="module-title" style="margin-bottom: 15px">登录设备统计</header>
            <el-select v-model="deviceCount" class="checkName" style="top: -8px" @change="changeTime('getDeviceInfo')">
                <el-option v-for="item in times"  :label="item.text" :key="item.value" :value="item.value"></el-option>
            </el-select>
            <div id="device-chart" style="height: 70px" v-loading="deviceLoading"></div>
         </header>

         <!-- 积分统计 v-loading="creditLoading"-->
         <article class="right-bd" >
           <header class="module-title">积分统计</header>
           <el-select v-model="staTime" class="checkName" @change="changeTime('getCompanyMonthPointBrokenLine')">
                <el-option v-for="item in times"  :label="item.text" :key="item.value" :value="item.value"></el-option>
            </el-select>
             
            <div id="creditLine" style="height:160px" v-loading="creditLoading"></div>
         </article>
        
         <!-- 积分排行 -->
         <footer class="right-ft" style="position:relative">
            <header class="module-title">积分排行榜</header>
            <div class="operate-btn">
              <el-button class="jf_button" @click="ranking(1)">全部</el-button>
              <el-button class="jf_button" @click="ranking(2)" style="margin-right: 10px">近30天</el-button>
              <el-date-picker
                size="small"
                v-model="dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 240px;"
                @change="changeDateRange"
              >
              </el-date-picker>
            </div>

             <el-table  :data="values" style="width: 100%" v-loading="rankLoading"  height="200">
               <el-table-column type="index" label="排名" width="80">
              </el-table-column>
                <el-table-column prop="name" label="姓名" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sumpoint"  label="产生积分" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" min-width="180" style="text-algin:center">
                  <template slot-scope="scope">
                    <span class="label-credit-queue" @click="handlePie(scope.row.userid,scope.row.name)">模块使用情况</span>
                    <span class="label-credit-queue tj" @click="handleLine(scope.row.userid,scope.row.name)">积分统计</span>
                  </template>
                </el-table-column>
            </el-table> 
             <!-- <el-col :span="24" style="margin-top:0;position:relative;top:10px;">
                <el-pagination 
                  layout="prev, pager, next"
                  :current-page="pageNumber" 
                  @current-change="handleCurrentChange" 
                  :page-size="pageSize" 
                  :total="total" 
                  style="float:right;">
                </el-pagination>
              </el-col>  -->
               
              <!-- <div v-if="masg2">
                <el-row style="width:100%;min-width:560px;" v-for="(val,index) in values" :key="index">
                  <div style="padding:20px 0;">
                    <img v-if="!val.photo" src="../../img/person.png" class="rank_left rank_img"/>
                    <img v-else :src="val.photo" class="rank_left rank_img"/>
                    <div class="rank_left rank_name">{{val.name}} </div>
                    <div class="rank_left rank_sump">{{val.sumpoint}} </div>
                    <el-progress class="rank_num rank_left" :text-inside="true" :percentage="val.num" :show-text='false'
                      :stroke-width="15" :color="customColor">
                    </el-progress>
                    <div class="rank_right rank_jfDiv">
                        <span type="text" class="but_span" @click="handleLine(val.userid,val.name)">积分统计</span>
                    </div>
                    <img src="../../img/line.png" class="rank_right rank_lineImg rank_tjImg"/>
                    <div class="rank_right rank_mkDiv">
                      <span type="text" class="but_span" @click="handlePie(val.userid,val.name)">模块使用情况</span>
                    </div>
                    <img src="../../img/pie.png" class="rank_right rank_pieImg rank_tjImg"/>
                  </div>
                </el-row>
                
              </div>
              <div v-else style="text-align:center;line-height:19;">无数据。。。</div> -->
         </footer>

       </el-col>
    </el-row>
    
   
    <el-dialog class="model-edit" title="选择人员" :visible.sync="personVisible" 
      :close-on-click-modal="false">
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;border:1px solid #dfe6ec;">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-select v-model="souch_value" placeholder="请选择" @change="changeSouch"  style="width:120px;">
            <el-option v-for="item in optionsSouch" :key="item.value"  
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-form-item>
            <el-input  v-model="proName" style="width:200px;"  @keyup.enter.native="getUser(1)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="getUser(1)">查询</el-button>
          </el-form-item>
        </el-form>
        <el-tag :key="tag" v-for="tag in dynamicTags" closable  :disable-transitions="false"
           @close="handleClose(tag)" > 
            {{tag}} 
        </el-tag>
        <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button>
      </el-col>
      <!--用户列表-->
      <el-table  :data="users" highlight-current-row  style="width: 100%;" 
      ref="users" :header-cell-style="getRowClass" @current-change="handleSelectionChange">
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <input type="checkbox" v-model="scope.row.checked" @change="changeFun"> 
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="账号" min-width="130" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="point" label="积分"  min-width="120" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="border:1px solid #dfe6ec;margin-top:0;">
        <el-pagination 
          layout=" prev, pager, next" :current-page="pageNumber2" @current-change="handleCurrentChange2" 
          :page-size="pageSize2"  :total="total2" style="float:right;">
        </el-pagination>
      </el-col>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click.native="personVisible = false">取消</el-button>
        <el-button type="primary" @click.native="userSubmit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog class="model-edit" title="近30天模块使用" :visible.sync="pieVisible" 
      :close-on-click-modal="false">
      <span style="position:absolute;left:30px;top:60px;">当前人员 : {{pieName}}</span>
      <div id="echartBT2" style=" height:360px"></div>
    </el-dialog>
    <el-dialog class="model-edit" title="近30天积分统计" :visible.sync="lineVisible" 
      :close-on-click-modal="false">
      <span style="position:absolute;left:30px;top:60px;">当前人员 : {{lineName}}</span>
        <div id="echartZXT2" style=" height:360px"></div>
    </el-dialog>
  </div>
</template>
<script>
import { API__code,API_Company,API_Stat,} from '../../../api/index.js'
import utils from '@/utils/index'
var echarts = require('echarts');
export default {
  props: ['defalutd','comId'],

  data(){
    return {

      // loading
      creditLoading: false,  // 积分统计
      rankLoading: false,    // 积分排行榜
      moduleLoading: false,  // 模块使用情况
      productLoading: false, // 产品统计
      deviceLoading: false,   // 登录设备统计

      modulePieArr: [],      // 左下模块使用情况
      chartObjArr: [],       // 保存Echarts实例对象， 做resize使用

      staTime:'1',      // 积分统计  一个月 1 三个月 3 六个月 6 十二个月 12
      moduleTime: '1',  // 模块使用情况
      pieColor: ['#5C89FF', '#7C6AF2',' #C95FF2','#FF6383','#5C89FF','#FF9F40','#FFCB48'],

      lineVisible:false,
      pieVisible:false,

      pageNumber:1,
      pageSize:6,
      total:1,
      proCPlist:false,
      checkPerson2:'',
      person2:'1',
      funCheck:1,//1表示饼图，2折线
      products:[],
      proNum:0,
      proXZ:0,
      proGQ:0,
      proJGQ:0,

      optionsSouch:[
        {value: '账号',label: '账号'},
        {value: '姓名',label: '姓名'}, 
        {value: '积分',label: '积分'},
      ],

      checkCode:'',
      token:'',
      id:'',
      companyuseid:'',
      checkUser:'',
      checkUser2:'',
      checkUserId:"",
      checkUserId2:"",
      personVisible:false,
      pageSize2:10,
      pageNumber2:1,
      total2:1,
      users:[],
      times:[
        {value:'1',text:'最近一个月'},
        {value:'3',text:'最近三个月'},
        {value:'6',text:'最近六个月'},
        {value:'12',text:'最近一年'},
      ],
      persons:[
				{ value: "1", text: "企业" },
				{ value: "2", text: "个人" },
      ],
      checkPerson:'',
      person:'1',
      values:[],
      // percentage:'',
      
      customColor: '#409eff',
      customColors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f7ad3', percentage: 100}
      ],
      flag:false,
      dynamicTags:[],
      proName:'',
      souchs:{},
      souch_value:'',
      dateTime:[],
      dataNum:[],
      masg:false,
      masg2:false,
      pieName:'',
      lineName:'',
      ranked:false,
      deviceCount: '1',  // 登录设备统计  一个月 1 三个月 3 六个月 6 十二个月 12
      
      dateRange: [], // 积分排行榜日期范围
      startTime: '', // 积分排行榜开始时间
      endTime: '' // 积分排行榜结束时间
    }
  },
  methods:{
    handleLine:function(id,name){
      this.lineName = name;
      this.lineVisible = true;
      this.getUserMonthPointBrokenLine2(id);
    },
    handlePie:function(id,name){
      this.pieName = name;
      this.pieVisible = true;
      this.getCompanyUserMonthModulePointPie2(id);
    },
    handleCurrentChange:function(val){
      this.pageNumber = val;
      if(this.ranked){
        this.getCompanyUserMonthPointList();
      }else{
        this.getCompanyUserPointList();
      }
    },
 
    
    // 积分统计 && 模块使用情况
    changeTime(method){
      this[method]();
    },

   
    userSubmit:function(){
      if(this.funCheck == 1){
        this.checkPerson2 = this.checkUser2;
        this.getCompanyUserMonthModulePointPie(this.checkUserId2);
      }else{
        this.checkPerson = this.checkUser;
        this.getUserMonthPointBrokenLine(this.checkUserId);
      }
      this.personVisible = false;
    },
    changeSouch:function(val){
      if(val == "姓名"){
        this.proName = this.souchs.name;
      }else if(val == "账号"){
        this.proName = this.souchs.phone;
      }else if(val == "积分"){
        this.proName = this.souchs.point;
      }
    },
    delTags2:function(){
      this.souchs = {};
      this.proName = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose(tag) {
      if(tag == "姓名"){
        this.souchs.name ="";
        if(this.souch_value == "姓名"){
          this.proName = '';
        }
      }
      if(tag == "账号"){
        this.souchs.phone ="";
        if(this.souch_value == "账号"){
          this.proName = '';
        }
      }
      if(tag == "积分"){
        this.souchs.point ="";
        if(this.souch_value == "积分"){
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleCurrentChange2(val) {
      this.pageNumber2 = val;
    },
    changeFun:function(){
      var falg = false;
      if(this.funCheck == 1){
        for(var i=0;i<this.users.length;i++){
          if(this.users[i].checked == true){
            falg = true;
            this.checkUserId2 = this.users[i].id;
          }
        }
        if(!falg){
          this.checkUserId2 = "";
        }
      }else{
        for(var i=0;i<this.users.length;i++){
          if(this.users[i].checked == true){
            falg = true;
            this.checkUserId = this.users[i].id;
          }
        }
        if(!falg){
          this.checkUserId = "";
        }
      }
    },
    handleSelectionChange (row) {
      this.flag = true;
      this.users.forEach(item => {
        if (item.id !== row.id) {
           item.checked = false;
        }
        if(item.id == row.id){
          item.checked = true;
        }
      });
      if(row.name  == null){
        row.name = "";
      }
      if(row.phone == null){
        row.phone = "";
      }
      if(this.funCheck == 1){
        this.checkUser2 = row.name;
        this.checkUserId2 = row.id;
      }else{
        this.checkUser = row.name;
        this.checkUserId = row.id;
      }
      
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
          return "background:#F5F7FA";
      } else {
          return "";
      }
    },
    handleUser:function(val){
      this.funCheck = val;
      this.personVisible = true;
      this.getUser();
    },
    getUser:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber2,
        pageSize:this.pageSize2,
        listType:'page',
        // invitestatus:'0',
        companyid:this.comId
      }
      API_Company.userList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data){
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i]){
                if(_this.funCheck == 1){
                  if(_this.checkUserId2 && res.data.data.list[i].id == _this.checkUserId2){
                    res.data.data.list[i].checked = true;
                  }else{
                    res.data.data.list[i].checked = false;
                  }
                }else{
                  if(_this.checkUserId && res.data.data.list[i].id == _this.checkUserId){
                    res.data.data.list[i].checked = true;
                  }else{
                    res.data.data.list[i].checked = false;
                  }
                }
              }
            }
            _this.total2 = res.data.data.totalRow;
            _this.users = res.data.data.list;
          }
        }else{
          _this.$message.error(res.data.message);
          if(res.data.code == 403){
            _this.$router.push({path: 'login'});
          }
        }
      }).catch(err =>{
        _this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    
    // 积分统计折线图
    creditDrawLine(dataTime, dataNumber){
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('creditLine'));
      this.chartObjArr.push(myChart)
      // 绘制图表
      myChart.setOption({
        tooltip: {
            trigger: 'axis'
        },
        grid: {
            top:'3.5%',
            left: '2%',
            right: '6%',
            bottom: '5%',
            containLabel: true
        },

        dataZoom: [
          {
            type: 'inside'
          }
        ],
        
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data:dataTime,
            axisLine: {
              lineStyle: {
                color: '#DBDBDB',
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {//y轴文字的配置
                textStyle: {
                     color: "#666",
                     margin: 15
                },
            },
        },

        yAxis: {
            type: 'value',
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#DBDBDB",
                }
            },
            axisTick: {
              show: false,
            },
            axisLabel: {//y轴文字的配置
                textStyle: {
                     color: "#666",
                     margin: 15
                },
            },
            splitLine: {
              show: false,
            },
        },
        series: [
            {
                name:'积分',
                type:'line',
                stack: '总量',
                data:dataNumber,
                showBackground: false,
                smooth: true,
                color: '#F66B3D',
                symbol: 'none',
                areaStyle: {
                  normal: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: 'rgba(249, 91, 71, 0.35)', // 0% 处的颜色
                        },
                        {
                          offset: 0.7,
                          color: 'rgba(249, 91, 71, 0.01)', // 100% 处的颜色
                        },
                      ],
                      globalCoord: false, // 缺省为 false
                    },
                  },
                },
            },
        ]
      });
    },

    echart4 :function(dataTime,dataNumber){
      var myChart = echarts.init(document.getElementById('echartZXT2'));
      myChart.setOption({
        tooltip: {
            trigger: 'axis'
        },
        grid: {
            top:'8%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data:dataTime,
            axisLine: {
              lineStyle: {
                color: '#DBDBDB',
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {//y轴文字的配置
                textStyle: {
                     color: "#666",
                     margin: 15
                },
            },
        },
        yAxis: {
            type: 'value',
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#DBDBDB",
                }
            },
            axisTick: {
              show: false,
            },
            axisLabel: {//y轴文字的配置
                textStyle: {
                     color: "#666",
                     margin: 15
                },
            },
            splitLine: {
              show: false,
            },
        },
        series: [
            {
                name:'积分',
                type:'line',
                stack: '总量',
                data:dataNumber,
                 showBackground: false,
                smooth: true,
                color: '#F66B3D',
                symbol: 'none',
                areaStyle: {
                  normal: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: 'rgba(249, 91, 71, 0.35)', // 0% 处的颜色
                        },
                        {
                          offset: 0.7,
                          color: 'rgba(249, 91, 71, 0.01)', // 100% 处的颜色
                        },
                      ],
                      globalCoord: false, // 缺省为 false
                    },
                  },
                },
            },
        ]
      });
    },
    
    // 模块使用情况
    echartModule(data1,data2){
      let _self = this;
      var myChart = echarts.init(document.getElementById('echartModule'));
      // 绘制图表
      myChart.setOption({
       
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        legend: {
            bottom: 10,
            left: 'center',
            data:data1,
            show: false
        },
        color: _self.pieColor,
        series : [
            {
                name: '模块名称',
                type: 'pie',
                radius : '50%',
                center: ['50%', '50%'],
                data:data2,
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },
                    // normal:{
                    //   color:function(params) {
                    //   //自定义颜色
                    //     var colorList = [          
                    //         '#CDDC39', '#E6EE9C', '#AEEA00', '#FFEA00', '#FFA000','#FFCC80',
                    //         '#F48FB1', '#FF5722', '#D50000', '#7B1FA2', '#7C4DFF','#B388FF',
                    //         '#3949AB', '#536DFE', '#8C9EFF', '#64B5F6', '#2196F3','#607D8B',
                    //         '#4CAF50', '#00E5FF','#64FFDA',
                    //     ];
                    //     return colorList[params.dataIndex]
                    //   }
                    // }
                }
            }
        ]
      });
    },

    echart3:function(data1,data2){
      var myChart = echarts.init(document.getElementById('echartBT2'));
      // 绘制图表
      myChart.setOption({
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
            bottom: 10,
            left: 'center',
            data:data1,
        },
        series : [
          {
            name: '模块名称',
            type: 'pie',
            radius : '55%',
            center: ['50%', '45%'],
            data:data2,
            itemStyle: {
                emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                normal:{
                  color:function(params) {
                  //自定义颜色
                    var colorList = [          
                        '#CDDC39', '#E6EE9C', '#AEEA00', '#FFEA00', '#FFA000','#FFCC80',
                        '#F48FB1', '#FF5722', '#D50000', '#7B1FA2', '#7C4DFF','#B388FF',
                        '#3949AB', '#536DFE', '#8C9EFF', '#64B5F6', '#2196F3','#607D8B',
                        '#4CAF50', '#00E5FF','#64FFDA',

                        // '#5C89FF', '#7C6AF2',' #C95FF2','#FF6383','#5C89FF','#FF9F40','#FFCB48'
                    ];
                    return colorList[params.dataIndex]
                  }
                }
            }
          }
        ]
      });
    },

    //读取cookie
    getCookie: function() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnypt_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnypt_checkCode') {
              this.checkCode = arr2[1];
          }
          // else if (arr2[0] == 'dnnypt_id') {
          //     this.id = arr2[1];
          // }
        }
      }
    },

    //企业产品总数
    getProductSum:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.comId,
      }
      API_Stat.getProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length > 0){
            this.proNum = res.data.data[0].num;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    //分类企业产品统计
    getGroupProductSum:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.comId,
      }
      this.productLoading = true
      API_Stat.getGroupProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length > 0){
            this.proCPlist = true;
            _this.products = res.data.data;
          }else{
            this.proCPlist = false;
          }
          this.productLoading = false
        }
      }).catch(err =>{
        this.productLoading = false
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //过期产品总数
    getDueProductSum:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.comId,
      }
      API_Stat.getDueProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length > 0){
            this.proGQ = res.data.data[0].num;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //闲置产品总数
    getUnusedProductSum:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.comId,
      }
      API_Stat.getUnusedProductSum(param)
      .then((res) =>{
        
        if(res.data.code == API__code.SUCCESS){
          
          if(res.data.data.length > 0){
            this.proXZ = res.data.data[0].num;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //将过期产品总数
    getDueInMonthProductSum:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.comId,
      }
      API_Stat.getDueInMonthProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length > 0){
            this.proJGQ = res.data.data[0].num;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    // 积分排行榜
    //企业个人总排行
    getCompanyUserPointList:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,

        // pageNumber:this.pageNumber,
        // pageSize:this.pageSize,

        pageNumber: 1,
        pageSize: 1000,
        listType:'page',
      }
      this.rankLoading = true;
      API_Stat.getCompanyUserPointList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.list.length>0){
            this.masg2 = true;
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i].sumpoint){
                res.data.data.list[i].num = parseInt((res.data.data.list[i].sumpoint/res.data.maxPoint)*100);
                if (res.data.data.list[i].num < 30) {
                  this.customColor = '#f56c6c';
                } else if (res.data.data.list[i].num < 70) {
                  this.customColor = '#5cb87a';
                } else {
                  this.customColor = '#67c23a';
                }
              }
            }
            this.values  = res.data.data.list;
            this.total = res.data.data.totalRow;
          }else{
            this.masg2 = false;
            this.values = [];
            this.total = 0;
          }
          this.rankLoading = false;
        }
      }).catch(err =>{
        this.rankLoading = false;
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //企业个人30天排行
    getCompanyUserMonthPointList:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
        // pageNumber:this.pageNumber,
        // pageSize:this.pageSize,
        pageNumber: 1,
        pageSize: 1000,
        listType:'page',
        startTime:this.startTime || undefined,
        endTime:this.endTime || undefined,
      }
      this.rankLoading = true;
      API_Stat.getCompanyUserMonthPointList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.list.length > 0){
            this.masg2 = true;
            var allsumpoint = 0;
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i].sumpoint){
                res.data.data.list[i].num = parseInt((res.data.data.list[i].sumpoint/res.data.maxPoint)*100);
                if (res.data.data.list[i].num < 30) {
                  this.customColor = '#f56c6c';
                } else if (res.data.data.list[i].num < 70) {
                  this.customColor = '#5cb87a';
                } else {
                  this.customColor = '#67c23a';
                }
              }
            }
            this.values  = res.data.data.list;
            this.total = res.data.data.totalRow;
          }else{
            this.masg2 = false;
            this.values = [];
            this.total = 0;
          }
          this.rankLoading = false;
        }
      }).catch(err =>{
        this.rankLoading = false;
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    
    // 积分排行榜
    ranking:function(val){
      if(val == 1){
        this.ranked = false;
        this.dateRange = [];
        this.startTime = '';
        this.endTime = '';
        this.getCompanyUserPointList();
      }else{
        this.ranked = true;
        const tempDate = utils.getNear30DaysStartDateAndEndDate(); // 近30天开始日期和结束日期
        this.dateRange = [tempDate.startDate, tempDate.endDate];
        this.startTime = tempDate.startDate;
        this.endTime = tempDate.endDate;
        console.log('tempDate', tempDate);
        console.log('this.dateRange', this.dateRange);
        console.log('this.startTime', this.startTime);
        console.log('this.endTime', this.endTime);
        
        this.getCompanyUserMonthPointList();
      }
    },
    changeDateRange: function(val){
      if(val && val.length > 0){
        this.startTime = val[0];
        this.endTime = val[1];
      } else {
        this.startTime = '';
        this.endTime = '';
      }
      console.log('this.startTime', this.startTime, 'this.endTime', this.endTime);
      
      this.getCompanyUserMonthPointList();
    },

    //积分统计
    getCompanyMonthPointBrokenLine() {
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
        count: this.staTime
      }
      this.creditLoading = true;
      API_Stat.getCompanyMonthPointBrokenLine(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.dateTime = [];
          this.dataNum = [];
          for(var i=0; i<res.data.data.length; i++ ) {
            // this.dateTime.push(res.data.data[i].date.substring(5).replace(/-/g,"月") + '日');
            this.dateTime.push(res.data.data[i].date)
            this.dataNum.push(res.data.data[i].sumpoint);
          }
          this.creditDrawLine(this.dateTime,this.dataNum);
          this.creditLoading = false;
        }
      });
    },

    //个人30天折线图
    getUserMonthPointBrokenLine:function(id){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:id,
      }
      API_Stat.getUserMonthPointBrokenLine(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.dateTime = [];
          this.dataNum = [];
          for(var i=0;i<res.data.data.length;i++){
            this.dateTime.push(res.data.data[i].date.substring(6));
            this.dataNum.push(res.data.data[i].sumpoint);
          }
          this.creditDrawLine(this.dateTime,this.dataNum);
        }
      });
    },
    //弹窗个人30天折线图
    getUserMonthPointBrokenLine2:function(id){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:id,
      }
      API_Stat.getUserMonthPointBrokenLine(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.dateTime = [];
          this.dataNum = [];
          for(var i=0;i<res.data.data.length;i++){
            this.dateTime.push(res.data.data[i].date.substring(5).replace(/-/g,"月") + '日');
            this.dataNum.push(res.data.data[i].sumpoint);
          }
          this.echart4(this.dateTime,this.dataNum);
        }
      });
    },

    //企业模块使用情况饼图
    getCompanyMonthModulePointPie:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
        count: this.moduleTime
      }
      this.moduleLoading = true;
      API_Stat.getCompanyMonthModulePointPie(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length>0){
            this.masg = false;
          }else{
            this.masg = true;
          }
          this.modulePieArr = res.data.data;
          var modulenames = [];
          var modul = [];
          for(var i=0;i<res.data.data.length;i++){
            modulenames.push(res.data.data[i].modulename);
            var json = {value:res.data.data[i].sumpoint, name:res.data.data[i].modulename}
            modul.push(json);
          }
          this.echartModule(modulenames,modul);
          this.moduleLoading = false;
        }
      });
    },

    //积分排行榜： 弹框中模块使用情况
    getCompanyUserMonthModulePointPie(id){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:id,
      }
      API_Stat.getCompanyUserMonthModulePointPie(param)
      .then((res) => {
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length>0){
            this.masg = false;
          }else{
            this.masg = true;
          }
          var modulenames = [];
          var modul = [];
          for(var i=0;i<res.data.data.length;i++){
            modulenames.push(res.data.data[i].modulename);
            var json = {value:res.data.data[i].sumpoint, name:res.data.data[i].modulename}
            modul.push(json);
          }
          
          this.echartModule(modulenames,modul);
        }
      });
    },

    //弹窗个人30天饼图
    getCompanyUserMonthModulePointPie2:function(id){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:id,
      }
      API_Stat.getCompanyUserMonthModulePointPie(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length>0){
            this.masg = false;
          }else{
            this.masg = true;
          }
          var modulenames = [];
          var modul = [];
          for(var i=0;i<res.data.data.length;i++){
            modulenames.push(res.data.data[i].modulename);
            var json = {value:res.data.data[i].sumpoint, name:res.data.data[i].modulename}
            modul.push(json);
          }
          this.echart3(modulenames,modul);
        }
      });
    },

    // 登录设备统计
    getOptionBar(data) {
        let option = {
            color: ['#F66B3D', '#3DBFF6'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'none'
                }
            },
            grid: {
              left: '95px',
              right: '6%',
              top: '1%',
              bottom: '0'
            },

            xAxis: {
              type: 'value',
              // 分割线
              splitLine:{
                show: false
              },
              axisLabel: {
                show: false,
              },
            
            },

            yAxis: {
              type: 'category',
              data:  ['企业用户(人)', '登录设备(台)'],
              // 网格线
              splitLine:{
                show: false
              },

              axisTick: { show: false },
              
              // y轴轴线
              axisLine: {
                show: false,
              },

              // y轴文本  
              axisLabel : {
                show : true,
                margin: 12,
                fontSize: '14',
                color: '#666',
              },
            },
           
            series: [
              {
                type: 'bar',
                data: [data.userCount,data.hardHashCount],
                barGap: '50%',
                barWidth: 20,
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      position: 'right',
                      textStyle: {
                        // color: "#F66B3D",
                        fontSize: 14
                      }
                    },
                    color:function(params) {
                        var colorList = [ '#3DBFF6', '#F66B3D'];
                        return colorList[params.dataIndex]
                    },
                  }
                }
              },
            
            ]
        }
        return option;
    },
    
    initChartDevice(data) {
      var myChart = echarts.init(document.getElementById('device-chart'));
      // 绘制图表
        // this.myChart = myChart;
        let option = this.getOptionBar(data); 
        option && myChart.setOption(option);
        this.chartObjArr.push(myChart)
    },

    getDeviceInfo() {
      console.log('getDeviceInfo')
       let param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: this.id,
        count: this.deviceCount,
        companyid: this.$route.query.companyId
      }
      this.deviceLoading = true;
      API_Stat.getLoginDevice(param)
      .then((res) =>{
        if(res.data.code == 200) {
          let data = res.data.data;
          data.userCount = parseInt(data.userCount)
         this.initChartDevice(res.data.data);
         console.log('res.data==getDeviceInfo', res.data)
        }
        this.deviceLoading = false;
      }).then(err => {
        this.deviceLoading = false;
      })
    },

    chartResize() {
      if(this.chartObjArr.length > 0) {
        this.chartObjArr.forEach(item => item.resize())
      }
    },
 
  
  },

  beforeDestroy() {
     window.removeEventListener("resize", this.chartResize);
  },

  
  mounted() {
 
      window.addEventListener("resize", this.chartResize);
      this.getProductSum();
      this.getGroupProductSum();
      this.getDueProductSum();
      this.getUnusedProductSum();
      this.getDueInMonthProductSum();
      // this.getCompanyUserMonthPointList();
      this.ranking(2);
      this.getCompanyMonthPointBrokenLine();
      this.getCompanyMonthModulePointPie();

      this.getDeviceInfo();
      
    
  },
  watch: {
    // 'defalutd': function (val) {
    //   if(val == 2){
    //     this.getProductSum();
    //     this.getGroupProductSum();
    //     this.getDueProductSum();
    //     this.getUnusedProductSum();
    //     this.getDueInMonthProductSum();
    //     this.getCompanyUserPointList();
    //     this.getCompanyMonthPointBrokenLine();
    //     this.getCompanyMonthModulePointPie();
    //   }
    // }
  },
  created(){
    this.companyuseid = this.comId
    this.getCookie();
  }
}
</script>
<style lang="scss">
 .fitSize {
     width: 100%;
     height: 100%;
  }
.company-stastics-box {
   min-width:1280px;
  .company-stastics-wrapper {
    // overflow: hidden;
    .company-stastics-item {
      padding: 20px 0;
      height: 100%;
      box-sizing: border-box;
      overflow: auto;
      &.left {
        padding-right: 20px;
        border-right: 1px solid #F7F7F7;
      }
     

      .left-hd {
        padding-bottom: 20px;
        text-align: center;
        user-select: none;
        border-bottom: 1px solid #F7F7F7;
        .x_icon{
          position: relative;
          left: 0;
          height:40px;
          width:40px;
        }

        .span_size {
          margin: 10px 0;
          color: #666;
          font-size: 14px;
        }

        .label_count{
          font-size: 20px;
          font-weight: Bold;
        }
        .zs {
          color:#F66B3D;
        }
        .ygq {
          color:#55BF3C;
        }
        .xz {
          color: #FCA63F;
        }
        .jgq {
          color:#38C8CD;
        }
      }

      .left-ft {
        position: relative;
        .search-select {
          position: absolute;
          right: 0;
          top: 0;
        }
        .pie-content {
          width: 100%;
          height: 300px;

          .pie-chart {
            height: 100%;
          }

          .pie-legend {
            display: flex;
            // align-items: ;
            // justify-content: center;
            justify-content: flex-start;
            flex-direction: column;
            padding-left: 6%;
            padding-top: 20px;
            padding-bottom: 12px;
            // height: 100%;
          }

          .legend-list {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            &:last-child {
              margin-bottom: 0;
            }
            .circle {
              width: 9px;
              height: 9px;
              border-radius: 100%;
            }
            .name {
              flex: 1;
              padding-left: 8px;
              color: #666;
              font-size: 14px;
            }
          }
        }
      }

      // 右侧样式统计
      &.right {
        padding: 0 20px;
        padding-right: 0;
        box-sizing: border-box;
      }

      .right-bd {
        position: relative;
        margin-bottom: 0;
      }
      
      .right-ft {
        .operate-btn {
          position: absolute;
          right: 0;
          top: 0;
        }

        .label-credit-queue {
          cursor: pointer;
          color: #4781F1;
          font-size: 14px;
          &:hover {
            opacity: .8;
          }
          &.tj {
            color: #F66B3D;
            padding-left: 24px;
          }
        }
      }

      .module-title {
        margin: 20px 0;
        color: #666;
        font-size: 16px;
      }

    }
  }
}

</style>
<style scoped>

  .el-col {
    border-radius: 4px;
  }

  .checkName{
    position: absolute;
    width:115px;
    right: 10px;
    top: -3px;
  }

  .souc {
    position: absolute;
    left: 90px;
  }


  .div_div{
    width:80%;
    position:relative;
    left:10%;
    height:1px;
    background:#EFF0F2;
  }
  .cptj_div{
    height:350px;
    overflow-x:auto;
  }
  .cptj_img{
    height:36px;
    width:36px;
  }
  .cptj_name{
    position: relative;
    left: 20px;
    top: -11px;
    font-size:18px;
    color:#333333;
  }
  .cptj_num{
    position: relative;
    right: 20px;
    top:12px;
    float:right;
    font-size:20px;
    color:#333333;
  }
  .cptj_bottom{
    position:relative;
    height:1px;
    background:#EFF0F2;
    top:15px;
  }
  .jf_button{
    width: 100px;
    height: 30px;
    line-height: 0;
  }
  .rank_left{
    position:relative;
    float:left;
  }
  .rank_img{
    left:3.5%;
    width:28px;
    height: 28px;
  }
  .rank_name{
    left:4.5%;
    top:3px;
    width:7.5%;
  }
  .rank_sump{
    left:4.5%;
    top:4.5px;
    width:7.5%;
  }
  .rank_right{
    position:relative;
    float:right;
  }
  .rank_jfDiv{
    right:10px;
    top:-5px;
    width:80px;
  }
  .rank_lineImg{
    right:15px;
  }
  .rank_mkDiv{
    right:30px;
    top:-6px;
  }
  .rank_pieImg{
    right:30px;
  }
  .rank_tjImg{
    width:24px;
    height:24px;
    border:1px dashed #FF6383;
  }
  .jczl_div{
    height: 100px;
    width: 100%;
    position: relative;
    left: 20px;
  }
.jczl_span1{
  font-size:20px;
  color:#666;
  font-weight:bold;
  position: relative;
  top:20px;
}
.jczl_span2{
  font-size:14px;
  color:#666;
  font-weight:normal;
  position: relative;
  top:30px;
}
.but_span{
  position:relative;
  top:8px;
  cursor:pointer;
  color:#666;
}
</style>



// WEBPACK FOOTER //
// static.vue?5ac07dbc